import React, { useState } from 'react'
import { Button, Card, Col, Form, Input, Row, Select, Table } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { useDeepEffect } from '../../utils/hooks'
import { fetchReportProblemList , updateReportProblemReport } from '../../modules/reportProblem'
import ReportProblemForm from './components/ReportProblemForm'
import _ from 'lodash'

const initialOptions = {
  size: 20,
  page: 0,
  keyword: undefined,
  type: 0,
  status: 0
}

const ReportProblem = ({ form }) => {
  const dispatch = useDispatch()
  const [visible, setVisible] = useState(false)
  const [formData, setFormData] = useState({})
  const { validateFields, getFieldDecorator } = form
  const [options, setOptions] = useState(initialOptions)

  const { reportProblemList, isLoading } = useSelector(
    (state) => ({
      reportProblemList: state.reportProblem.reportProblemList,
      isLoading: state.reportProblem.isLoading
    }),
    []
  )

  async function fetchData() {
    await dispatch(fetchReportProblemList(options))
  }

  useDeepEffect(() => {
    fetchData()
  }, [])

  async function onShowSizeChange(current, pageSize) {
    options.size = pageSize
    setOptions(options)
    await dispatch(fetchReportProblemList(options))
  }

  async function onChange(page) {
    options.page = page - 1
    setOptions(options)
    await dispatch(fetchReportProblemList(options))
  }

  const onClick = (e, record) => {
    e.preventDefault()
    setVisible(true)
    setFormData(record)
  }

  const onCloseModal = async () => {
    await dispatch(fetchReportProblemList(options))
    await setVisible(false)
  }

  const onOk = async (data) => {
    if (!_.isEmpty(formData)) {
      await dispatch(updateReportProblemReport(data))
    } 
    await dispatch(fetchReportProblemList(options))
    await setVisible(false)
    await setFormData({})
  }

  const columns = [
    {
      title: 'ลำดับ',
      width: 80,
      align: 'center',
      render: (_text, _record, index) => (
        <span>{options.page * options.size + index + 1}</span>
      )
    },
    {
      title: 'สถานะ',
      dataIndex: 'status',
      width: 150,
      align: 'center',
      render: (text) => <span>{text || '-'}</span>
    },
    {
      title: 'ประเภท',
      dataIndex: 'type',
      width: 100,
      align: 'center',
      render: (text) => <span>{text || '-'}</span>
    },
    {
      title: 'รายละเอียด',
      dataIndex: 'detail',
      align: 'center',
      render: (text) => <span>{text || '-'}</span>
    },
    {
      title: 'เพิ่มเติม',
      dataIndex: 'additional',
      align: 'center',
      render: (text) => <span>{text || '-'}</span>
    },
    {
      title: 'ผู้รายงาน',
      dataIndex: 'reportBy',
      align: 'center'
    },
    {
      title: 'Action',
      key: 'action',
      fixed: 'right',
      width: 100,
      render: (text, record) => (
        <span>
          <Button
            type="primary"
            size="small"
            shape="circle"
            icon="edit"
            onClick={(e) => {
              onClick(e, record)
            }}
          />
        </span>
      )
    }
  ]

  const reset = async (e) => {
    e.preventDefault()
    options.keyword = undefined
    options.type = 0
    options.status = 0
    await dispatch(fetchReportProblemList(options))
    await form.resetFields()
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        if (values.keyword) {
          options.keyword = values.keyword
          options.page = 0
        } else {
          options.keyword = ''
          options.page = 0
        }
        if (values.status !== 0) {
          options.status = values.status
          options.page = 0
        } else {
          options.status = ''
          options.page = 0
        }
        if (values.type !== 0) {
          options.type = values.type
          options.page = 0
        } else {
          options.type = ''
          options.page = 0
        }
        setOptions(options)
        dispatch(fetchReportProblemList(options))
      }
    })
  }

  return (
    <Row type="flex" gutter={[8, 8]}>
      <Col span={24}>
        <Card>
          <Form layout="vertical" colon={false} onSubmit={handleSubmit}>
            <Row gutter={8} type="flex" justify="space-between">
              <Col span={18}>
                <Row gutter={8}>
                  <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                    <Form.Item label="ค้นหาข้อมูลรายงาน">
                      {getFieldDecorator('keyword')(
                        <Input placeholder="รายละเอียด,ผู้รายงาน" />
                      )}
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                    <Form.Item label="ประเภทรายงาน">
                      {getFieldDecorator('type', { initialValue: 0 })(
                        <Select showArrow={true}>
                          <Select.Option value={0}>ทั้งหมด</Select.Option>
                          <Select.Option value={'HERO'}>HERO</Select.Option>
                          <Select.Option value={'RECYCLE'}>RECYCLE</Select.Option>
                          <Select.Option value={'PRODUCT'}>PRODUCT</Select.Option>
                        </Select>
                      )}
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                    <Form.Item label="สถานะรายงาน">
                      {getFieldDecorator('status', { initialValue: 0 })(
                        <Select showArrow={true}>
                          <Select.Option value={0}>ทั้งหมด</Select.Option>
                          <Select.Option value={'PENDING'}>
                          PENDING
                          </Select.Option>
                          <Select.Option value={'APPROVED'}>
                          APPROVED
                          </Select.Option>
                          <Select.Option value={'REJECT'}>REJECT</Select.Option>
                        </Select>
                      )}
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
              <Col>
                <Form.Item label="" style={{ marginTop: '1.75rem' }}>
                  <Row gutter={8} type="flex">
                    <Col>
                      <Button type="primary" htmlType="submit">
                        ค้นหา
                      </Button>
                    </Col>
                    <Col>
                      <Button type="danger" onClick={(e) => reset(e)}>
                        รีเซ็ต
                      </Button>
                    </Col>
                  </Row>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Card>
      </Col>
      <Col span={24}>
        <Table
          loading={isLoading}
          rowKey={(record) => {
            return record.id
          }}
          bordered
          dataSource={reportProblemList.content}
          columns={columns}
          pagination={{
            current: reportProblemList.pageable.pageNumber + 1,
            pageSize: reportProblemList.size,
            pageSizeOptions: ['10', '20', '50', '100'],
            showSizeChanger: true,
            onShowSizeChange: onShowSizeChange,
            onChange: onChange,
            total: reportProblemList.totalElements
          }}
        />
        <ReportProblemForm
        visible={visible}
        onOk={onOk}
        onCancel={onCloseModal}
        formData={formData}
      />
      </Col>
    </Row>
  )
}

const WrappedReportProblem = Form.create({
  name: 'WrappedReportProblem'
})(ReportProblem)

export default WrappedReportProblem
